/**
 * Rafraîchissement périodique qui s'arrête quand l'onglet est caché, avec un
 * rafraîchissement immédiat au retour si la dernière mise à jour est ancienne.
 * Renvoie la fonction d'arrêt (à appeler dans le nettoyage du useEffect).
 */
export const startVisibleInterval = (callback, intervalMs) => {
  let lastRun = Date.now();
  const run = () => {
    lastRun = Date.now();
    callback();
  };
  const timer = window.setInterval(() => {
    if (document.visibilityState === 'visible') run();
  }, intervalMs);
  const onVisibilityChange = () => {
    if (document.visibilityState === 'visible' && Date.now() - lastRun >= intervalMs) run();
  };
  document.addEventListener('visibilitychange', onVisibilityChange);
  return () => {
    window.clearInterval(timer);
    document.removeEventListener('visibilitychange', onVisibilityChange);
  };
};
